module.exports = __webpack_public_path__ + "img/1.08a03892.png";